// Import the necessary components
import VerofreshRecord from './VerofreshRecord'
class LanguageRecord extends VerofreshRecord {
}

export default LanguageRecord
